import Backbone from 'backbone';

var DemoComparePreference = Backbone.Model.extend({
    backend: 'gcapi',
    url: '/userpreference-service/demographicComparisonPreferences'
});

export default DemoComparePreference;
